// DEVELOPMENT
//import { environment } from 'src/environments/environment';
// STAGING
 // import { environment } from 'src/environments/environment.staging';
// PRODUCTION
import { environment } from 'src/environments/environment';

import { isPlatformBrowser } from '@angular/common';
import { AppConstants } from './app-constants';
import { PlatformLocation } from '@angular/common';

export class AppSettings {

    public static API_ENDPOINT: string = environment.api_endpoint;
    public static IMPORT_ENDPOINT: string = '';
    public static SERVER_ERR: string = 'Server Error!';

    public static getCurrentUser(platformId = null): any {
        if (isPlatformBrowser(platformId)) {
            return JSON.parse(localStorage.getItem(AppConstants.LOCAL_STORAGE_ID));
        } else {
            return null;
        }
    }

    public static getCurrentUserId(platformId = null): any {
        const userId = AppSettings.getCurrentUser(platformId) ? AppSettings.getCurrentUser(platformId).userId : null;
        return (userId == null) ? undefined : userId;
    }


}
export function initAppSettings(pl: PlatformLocation) {
    return () => {
        AppSettings.IMPORT_ENDPOINT =
        `https://${pl.hostname}/wp-content/plugins/skillstat-ecg`;
    };
}